exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".landing-video-text .valentine{font-size:26px;font-size:1.625rem}.landing-video-text .icon-item{left:-3.5rem;position:absolute;transform:scaleX(-1) rotate(-20deg)}.landing-video-text .btn{border-style:solid;border-width:1px}", ""]);

